document.addEventListener('DOMContentLoaded', function() {
  const topMenuLinks = document.querySelectorAll('.product__top-menu-link');
  
  // Handle menu link clicks
  topMenuLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      // Check if it's an external URL or internal page link
      if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('/')) {
        // Allow normal navigation for external URLs and internal pages
        return;
      } else if (href.startsWith('#')) {
        // Handle anchor links for smooth scrolling
        e.preventDefault();
        const targetId = href.substring(1);
        const targetSection = document.getElementById(targetId);
        
        if (targetSection) {
          const offsetTop = targetSection.offsetTop - 80; // Account for sticky menu
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }
    });
  });
  
  // Update active state on scroll for anchor links only
  function updateActiveMenu() {
    const scrollPosition = window.scrollY + 100;
    const anchorLinks = Array.from(topMenuLinks).filter(link => 
      link.getAttribute('href').startsWith('#')
    );
    
    if (anchorLinks.length === 0) return;
    
    let activeSection = null;
    anchorLinks.forEach(link => {
      const targetId = link.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);
      
      if (targetSection) {
        const sectionTop = targetSection.offsetTop;
        const sectionHeight = targetSection.offsetHeight;
        
        if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          activeSection = targetSection;
        }
      }
    });
    
    // Remove active class from all links
    topMenuLinks.forEach(link => link.classList.remove('active'));
    
    // Add active class to current section link
    if (activeSection) {
      const activeLink = document.querySelector(`.product__top-menu-link[href="#${activeSection.id}"]`);
      if (activeLink) {
        activeLink.classList.add('active');
      }
    }
  }
  
  // Initial update and scroll listener
  updateActiveMenu();
  window.addEventListener('scroll', updateActiveMenu);
  
  // Handle mobile scroll behavior
  function handleMobileScroll() {
    const menuList = document.querySelector('.product__top-menu-list');
    if (window.innerWidth <= 749 && menuList) {
      // Enable smooth horizontal scrolling on mobile
      let isDown = false;
      let startX;
      let scrollLeft;

      menuList.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - menuList.offsetLeft;
        scrollLeft = menuList.scrollLeft;
      });

      menuList.addEventListener('mouseleave', () => {
        isDown = false;
      });

      menuList.addEventListener('mouseup', () => {
        isDown = false;
      });

      menuList.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - menuList.offsetLeft;
        const walk = (x - startX) * 2;
        menuList.scrollLeft = scrollLeft - walk;
      });
    }
  }
  
  handleMobileScroll();
  window.addEventListener('resize', handleMobileScroll);
});
